<template>
    <div class="flex gap-3 justify-start">
        <hts-dropdown
            :options="tests"
            placement="bottom-start"
            :offset="[0, 15]"
            label-key="label"
            :hover="false"
            :multiple-level="true">
            <template #reference>
                <hts-form-button
                    icon-name="hi-funnel-icon"
                    icon-position="left"
                    type="button">
                    Lọc
                </hts-form-button>
            </template>
        </hts-dropdown>
        <hts-dropdown
            :options="tests"
            placement="bottom-start"
            :offset="[0, 15]"
            label-key="label"
            :hover="false"
            :multiple-level="true">
            <template #reference>
                <hts-form-button
                    icon-name="hi-chevron-down-icon"
                    icon-position="right"
                    type="button">
                    Trạng thái vận hành
                </hts-form-button>
            </template>
        </hts-dropdown>
        <hts-dropdown
            :options="tests"
            placement="bottom-start"
            :offset="[0, 15]"
            label-key="label"
            :hover="false"
            :multiple-level="true">
            <template #reference>
                <hts-form-button
                    icon-name="hi-chevron-down-icon"
                    icon-position="right"
                    type="button">
                    Loại cont / Loại xe
                </hts-form-button>
            </template>
        </hts-dropdown>
        <hts-dropdown
            :options="tests"
            placement="bottom-start"
            :offset="[0, 15]"
            label-key="label"
            :hover="false"
            :multiple-level="true">
            <template #reference>
                <hts-form-button
                    icon-name="hi-chevron-down-icon"
                    icon-position="right"
                    type="button">
                    Manual/Auto Điều phối
                </hts-form-button>
            </template>
        </hts-dropdown>
    </div>
</template>
<script setup lang="ts">
const tests = [
  {
    label: 'test1',
    class: 'text-gray-600'
  },
  {
    label: 'test2',
    class: 'text-gray-600'
  }
]
</script>
